





















import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { SelectProps, InputResponse } from '@/constants/form/types';

@Component({})
export default class Select extends Vue {
  // name属性
  @Prop({ default: '' })
  private name!: string;
  // セレクトリストデータ
  @Prop({ default: () => ({ name: '', options: [] }) })
  public selectData!: SelectProps;
  // 選択可能か制御
  @Prop({ default: false })
  public isDisabled?: boolean;
  // 初期選択value
  @Prop()
  public value?: { [k: string]: string };

  public selected: { [k: string]: string } = {};

  mounted() {
    if (this.value) {
      this.selected = this.value;
    }
  }

  @Watch('value')
  watchValue() {
    if (this.value) {
      this.selected = this.value;
    }
  }

  /**
   * 親コンポーネントに選択値を通知する
   * @module inputOpratipon
   * @return InputResponse - 要素名と入力値
   */
  @Emit('changeSelect')
  public changeSelect(): InputResponse {
    return { name: this.name, value: this.selected.value };
  }
}
